import { coerceStringArrayField } from './coerce-string-array-field';

/**
 * DisplayJob list fields are typed as string[] but some pipelines store a single string —
 * or processor junk (the literal "[object Object]"), which must never reach structured data.
 * JSON-LD JobPosting expects comma-separated Text for these properties.
 */
export function joinDisplayJobTextList(val: string | string[] | undefined | null): string | undefined {
  // Stringify safe primitives (numbers/booleans) but let objects fall through to
  // coerceStringArrayField, which drops non-strings — String(object) is how the
  // "[object Object]" junk gets minted in the first place.
  const normalized = Array.isArray(val)
    ? val.map((x) => (typeof x === 'number' || typeof x === 'boolean' ? String(x) : x))
    : val;
  const parts = coerceStringArrayField(normalized)
    .map((x) => x.trim())
    .filter((x) => x !== '');
  return parts.length === 0 ? undefined : parts.join(', ');
}
